export { SalesforceAccountStatus, Step, TunnelType } from './navigation'

export const HTTP_BAD_REQUEST_CLIENT_ERROR = 400
export const HTTP_NOT_FOUND_CLIENT_ERROR = 404
export const HTTP_INTERNAL_SERVER_ERROR = 500
